import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { useRouter } from "next/router";
import WButton from "../wbutton/WButton";
import { color, motion } from "framer-motion";
import clsx from "clsx";
import parse from "html-react-parser";
import fbEvent from "@/utils/fbEvent";
import Image from "next/image";

/* eslint-disable-next-line */
export interface LDarkWithTextBox {
  id?: string;
  topTitle?: string;
  topTitleColor?: string;
  mainTitle: string;
  mainTitleColor?: string;
  box: boolean;
  boxColor?: string;
  boxTitle?: string;
  boxTitleColor?: string;
  boxText?: string; //rich text
  boxTextColor?: string;
  bottomTitle?: string;
  buttonTitleColor?: string;
  button?: {
    color?: string;
    text: string;
    textColor?: string;
    url: string;
  };
  backgroundImageUrl?: string;
  mobileBackgroundImage?: string;
  centerText?: boolean;
  // Todo adauga varianta de mobile
}

export function LDarkWithTextBox(props: LDarkWithTextBox) {
  const router = useRouter();
  return (
    <div
      id={props?.id}
      className="relative py-20 h-screen bg-ekblue mt-14 lg:mt-16 overflow-hidden"
    >
      {props?.backgroundImageUrl && (
        <Image
          src={props.backgroundImageUrl}
          alt="Background"
          fill
          priority
          className="object-cover hidden md:block"
          quality={80}
          sizes="100vw"
        />
      )}
      {props?.mobileBackgroundImage && (
        <Image
          src={props.mobileBackgroundImage}
          alt="Background"
          fill
          priority
          className="object-cover block md:hidden"
          quality={80}
          sizes="100vw"
        />
      )}
      <div
        className={clsx([
          props?.centerText && "text-center justify-center",
          "container z-20 flex flex-col gap-10 px-4 mx-auto text-white lg:max-w-7xl relative",
        ])}
      >
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 1, type: "spring", delay: 0.4 }}
          className="relative flex flex-col w-full lg:w-7/12 gap-5 p-10 rounded-xl"
        >
          <div
            className="absolute inset-0 rounded-xl"
            style={{
              backgroundColor: props.box
                ? props.boxColor
                : "rgba(255, 255, 255, 0.1)",
              opacity: 0.8,
            }}
          />
          <div className="relative z-10">
            <div
              style={{ color: props.topTitleColor }}
              className="mb-2 text-xl font-semibold text-ekgreen"
            >
              {props?.topTitle}
            </div>
            <h1
              className="text-white mb-4"
              style={{
                color: props.mainTitleColor,
              }}
            >
              {parse(props?.mainTitle)}
            </h1>
            <h3
              className="text-white mb-4"
              style={{
                color: props.boxTitleColor,
              }}
            >
              {props?.boxTitle}
            </h3>
            {props?.boxText && (
              <div
                className="mb-4"
                style={{
                  color: props.boxTextColor,
                }}
              >
                <ReactMarkdown
                  // eslint-disable-next-line react/no-children-prop
                  children={props?.boxText}
                />
              </div>
            )}
            <div className="mt-8">
              <h3
                style={{ color: props.buttonTitleColor }}
                className="text-white mb-4"
              >
                {props?.bottomTitle}
              </h3>
            </div>
            <div className={clsx([props?.centerText && "mx-auto", "mt-10"])}>
              {props?.button?.text && (
                <WButton
                  text={props?.button?.text}
                  color={props?.button?.color}
                  textColor={props?.button?.textColor}
                  type="primary"
                  className="w-fit lg:mx-0"
                  onClick={() => {
                    props?.button?.url && router.push(props?.button.url);
                    fbEvent("Schedule");
                  }}
                />
              )}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default LDarkWithTextBox;
